/*
 * @Author: fremember
 * @Date: 2021-01-14 09:29:24
 * @Description: 
 */
import { GetterTree } from 'vuex'
import { ActionContext } from './../interface'
import { Caxios } from './../../utils/axios'
export interface State {
        personalData: any;
        areaSchoolList: Array<any>;
        allFlag: number;
        attrEmptyFlag: number;
        updateFlag: string;
        hasWorkFlag: boolean;
    }

let state: State = {
        personalData: {},
        areaSchoolList: [],
        allFlag: -1,
        attrEmptyFlag: -1,
        updateFlag: '',
        hasWorkFlag: false
    },
    getters: GetterTree<State, any> = {
        personalData: (state: State) => state.personalData,
        areaSchoolList: (state: State) => state.areaSchoolList,
        allFlag: (state: State) => state.allFlag,
        attrEmptyFlag: (state: State) => state.attrEmptyFlag,
        updateFlag: (state: State) => state.updateFlag,
        hasWorkFlag: (state: State) => state.hasWorkFlag
    },
    mutations = {
        setPersonalData (state: State, personalData: any): void {
            state.personalData = personalData
        },
        setAreaSchoolList (state: State, areaSchoolList: Array<any>): void {
            state.areaSchoolList = areaSchoolList
        },
        setAllFlag (state: State): void {
            state.allFlag = Math.random()
        },
        setAttrEmptyFlag (state: State): void {
            state.attrEmptyFlag = Math.random()
        },
        setUpdateFlag (state: State, updateFlag: string): void {
            state.updateFlag = updateFlag
        },
        setHasWorkFlag(state: State, hasWorkFlag: boolean): void {
            state.hasWorkFlag = hasWorkFlag
        },
    },
    actions = {
        setPersonalData(context: ActionContext, personalData: any): void {
            let { commit } = context
            commit('setPersonalData', personalData)
        },
        async areaSchool (context: ActionContext, schoolId: string) {
            let { commit } = context,
                result: any = await Caxios.get({ url: `/api/official/areaschoole?branch_school_id=${schoolId}` });
            commit('setAreaSchoolList', result)
        },
        async getPersonData(context: ActionContext, id: string) {
            let { commit } = context,
                result: any = await Caxios.get({ url: `/api/official/student/${id}` });
            if(result.id) {
                commit('setPersonalData', result)
                localStorage.setItem('fangtian_personal_Data', JSON.stringify(result))
            }
        },
        async editbase(context: ActionContext, editForm: any) {
            let { commit, dispatch } = context,
                result: any = await Caxios.post({ url: '/api/official/personal/editbase', data: editForm });
            if (result) {
                dispatch('getPersonData', editForm.id)
            }
            commit('setUpdateFlag', result.msg ? result.msg : '信息修改成功')
        },
        async getDailyWorksCount (context: ActionContext, id: string) {
            let { commit, dispatch } = context,
                result: any = await Caxios.get({ url: `/api/dailywork/getDailyWorksCount?stdid=${id}` });
            if(result && result > 0) {
                commit('setHasWorkFlag', true)
            } else {
                commit('setHasWorkFlag', false)
            }
        }
    },
    personal = {
        namespaced: true,
        state,
        getters,
        mutations,
        actions
    };

export default personal